import React from "react";
function LifestyleSegment() {
    return (
      <div>
        <h3>Lifestyle</h3>
  
        <h4>Fashion</h4>
        <p>
          Fashion is an ever-evolving industry that encompasses clothing, accessories, and personal style. It includes trends, fashion shows, designer profiles, and tips for creating stylish looks. Stay updated with the latest fashion news, learn about sustainable fashion practices, and explore different styles and aesthetics.
        </p>
  
        <h4>Health and Wellness</h4>
        <p>
          Health and wellness are essential aspects of a balanced lifestyle. Discover articles on fitness, nutrition, mental health, self-care, and mindfulness. Learn tips for maintaining a healthy lifestyle, explore different workout routines, and find inspiration for living a happier and healthier life.
        </p>
  
        {/* Add more subsegments and content as needed */}
      </div>
    );
  }
  
  export default LifestyleSegment;
  